<template>
    <section-con :main="main" :sub="sub">
        <div class="subject-intro">
            <div class="subject-item" v-for="(item, index) in filterData" :key="index">
                <img class="sub-img" :src="item.img">
                <p class="sub-name">{{item.name}}</p>
            </div>
        </div>
    </section-con>
</template>
<script>
import { subjectList } from '@/const'
export default {
    props: {
        hasSub: {
            type: Array,
            default: () => [1, 2, 3, 4, 5]
        },
        main: {
            type: String,
            default: '小学·初中全学科覆盖教育'
        },
        sub: {
            type: String,
            default: '方便机构扩展学科课程，拉高教学基础'
        }
    },
    data () {
        return {
            subjectList: subjectList
        }
    },
    computed: {
        filterData () {
            return this.subjectList.filter(item => this.hasSub.indexOf(item.id) > -1)
        }
    }
}
</script>
<style lang="scss" scoped>
.subject-intro{
    padding: 0px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    .subject-item{
        margin-right: 10px;
        .sub-img{
            width: 58px;
            height: 58px;
        }
        .sub-name{
            font-size:12px;
            font-family:PingFangSC-Medium,PingFang SC;
            font-weight:500;
            color:#282828;
            line-height:17px;
        }
        &:last-of-type{
            margin-right: 0px;
        }
    }
}
</style>